import type { ApolloClientOptions } from '@apollo/client/core';
import { ApolloLink, InMemoryCache } from '@apollo/client/core';
import type { HttpLink } from 'apollo-angular/http';
import extractFiles from 'extract-files/extractFiles.mjs';
import isExtractableFile from 'extract-files/isExtractableFile.mjs';
import { environment } from 'src/environments/environment';
import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev';
import type { Injector } from '@angular/core';
import { authLink } from './authLink';
import { retryLink } from './retryLink';

export const createApollo = (
  httpLink: HttpLink,
  injector: Injector,
  uri: string,
): ApolloClientOptions<unknown> => {
  if (!environment.production) {
    loadDevMessages();
    loadErrorMessages();
  }
  return {
    link: ApolloLink.from([
      retryLink(injector),
      authLink(injector),
      httpLink.create({
        uri,
        extractFiles: (body) => extractFiles(body, isExtractableFile),
      }),
    ]),
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: { fetchPolicy: 'cache-and-network' },
      query: { fetchPolicy: 'no-cache' },
      mutate: { fetchPolicy: 'no-cache' },
    },
  };
};
